import { DateHelper, DateType } from '@utils/DateHelper';
import { Declension } from '@utils/Declension';
import { isDefined } from '@utils/isDefined';
import { translate } from '@chaika/i18n/helper';

export function getAgeDifference(birthDate?: DateType, actualOn: DateType = new Date()): string {
    const { years = 0, months = 0, days = 0 } = isDefined(birthDate) ? DateHelper.getAge(birthDate, actualOn) : {};

    const ageDifference: string[] = [`${years} ${Declension.years(years)}`, `${months} ${Declension.months(months)}`];

    let difference = '';

    if (years >= 2) {
        difference = ageDifference[0];
    } else if (years > 0 && months > 0) {
        difference = ageDifference.join(' ');
    } else if (years > 0 && months === 0) {
        difference = `${ageDifference[0]} ${days} ${Declension.days(days)}`;
    } else if (years === 0 && months > 0) {
        difference = ageDifference[1];
    } else if (days >= 0) {
        difference = `${days} ${Declension.days(days)}`;
    } else {
        difference = `0 ${translate('years')}`;
    }

    return difference;
}
